<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             title="派工确认"
             @open="open"
             @closed="closed"
             width="1060px">
    <el-tabs v-model="activeName" style="height: 500px">
      <el-tab-pane name="1">
        <template #label>
          <span style="padding: 0 50px; cursor: pointer">派工信息确认</span>
        </template>
        <dispatch-panel :work="work" :dispatch-list="dispatchList" :loading="loading"
                        pattern="CONFIRM"></dispatch-panel>
      </el-tab-pane>
      <el-tab-pane name="2">
        <template #label>
          <span style="padding: 0 50px; cursor: pointer">车辆维修信息</span>
        </template>
        <div v-if="!work.lossDeterm" v-loading="true" style="height: 400px"></div>
        <loss-determ-panel v-else pattern="READ" :loss-determ="work.lossDeterm" :work="work">
        </loss-determ-panel>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <el-button type="primary" @click="confirm" :disabled="loading">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { afterWorkProcedures, confirmWork, getWorkDetail } from '@/utils/request'
  import DispatchPanel from '@/views/kanban/dialog/confirm-work/DispatchPanel'
  import LossDetermPanel from '@/views/kanban/dialog/add-check/LossDetermPanel'

  export default {
    name: 'ConfirmWorkDialog',
    mixins: [shareDataMixin],
    components: {
      LossDetermPanel,
      DispatchPanel
    },
    props: {
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        activeName: '1',
        loading: false,
        dispatchList: {}
      }
    },
    methods: {
      open () {
        this.loading = true
        afterWorkProcedures(this.work.id).then(response => {
          this.dispatchList = response.data
        }).finally(() => {
          this.loading = false
        })
        getWorkDetail(this.work.id).then(work => {
          this.work.lossDeterm = work.lossDeterm
          this.work.brandModel = work.brandModel
        })
      },
      closed () {
        this.activeName = '1'
        this.dispatchList = {}
      },
      cancel () {
        this.hide()
      },
      confirm () {
        this.work.loading = true
        confirmWork({
          workId: this.work.id,
          procedures: this.dispatchList.procedures
        }).then(() => this.hide())
          .catch(() => {
            this.work.loading = false
          })
      },
      hide () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
